module.exports = __webpack_public_path__ + "img/2.6022048a.png";